import { Check, X } from "lucide-react";
import { fmtDate } from "../../lib/adminApi";

const statusCls = (status) =>
  status === "approved"
    ? "bg-emerald-100 text-emerald-800"
    : status === "rejected"
    ? "bg-red-100 text-red-700"
    : "bg-amber-100 text-amber-800";

export const ApplicationsTable = ({ rows, busy, onDecide }) => (
  <table data-testid="admin-applications-table" className="w-full text-left text-sm">
    <thead>
      <tr className="border-b border-forest/10 text-xs font-bold uppercase tracking-[0.15em] text-forest/50">
        <th className="px-6 py-4">Name</th>
        <th className="px-6 py-4">Email</th>
        <th className="px-6 py-4">Phone</th>
        <th className="px-6 py-4">Role</th>
        <th className="px-6 py-4">Applied</th>
        <th className="px-6 py-4">Status</th>
        <th className="px-6 py-4">Decision</th>
      </tr>
    </thead>
    <tbody>
      {rows.length === 0 && (
        <tr>
          <td colSpan={7} className="px-6 py-10 text-center text-forest/40">
            Nothing here yet.
          </td>
        </tr>
      )}
      {rows.map((r) => (
        <tr key={r.id} className="border-b border-forest/5 font-semibold text-forest last:border-0">
          <td className="px-6 py-4">{r.name}</td>
          <td className="px-6 py-4">{r.email}</td>
          <td className="px-6 py-4">{r.phone}</td>
          <td className="px-6 py-4">
            <span
              className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${
                r.role === "driver" ? "bg-fresh/15 text-fresh" : "bg-forest/10 text-forest"
              }`}
            >
              {r.role}
            </span>
          </td>
          <td className="px-6 py-4 text-forest/60">{fmtDate(r.created_at)}</td>
          <td className="px-6 py-4">
            <span
              data-testid={`status-${r.id}`}
              className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${statusCls(r.status || "pending")}`}
            >
              {r.status || "pending"}
            </span>
          </td>
          <td className="px-6 py-4">
            <div className="flex gap-2">
              <button
                type="button"
                title="Approve"
                disabled={busy === r.id}
                data-testid={`approve-${r.id}`}
                onClick={() => onDecide(r.id, "approved")}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-600 text-white transition-colors hover:bg-emerald-700 disabled:opacity-50"
              >
                <Check className="h-4 w-4" />
              </button>
              <button
                type="button"
                title="Reject"
                disabled={busy === r.id}
                data-testid={`reject-${r.id}`}
                onClick={() => onDecide(r.id, "rejected")}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-red-600 text-white transition-colors hover:bg-red-700 disabled:opacity-50"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
